<template>
  <div class="animated fadeIn" id="list-decomptes">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-justify mr-2"></i>
          <strong>Gestion des segments des dossiers</strong>
        </div>
        <b-card-body class="small-padding">
          <b-row class="">
            <b-col md="6">
              <SlickList  lockAxis="y" v-model="allSegments" class="list-group" :useDragHandle="true" @sort-end="">
                <item-list v-for="(segment, index) in allSegments" :index="index" :key="index" :item="segment" :selectedItemId="segmentId">{{ segment.libelle }}<i v-if="canManageSegment()" class="icon fa fa-trash float-right clickable ml-2 text-danger" @click="deleteSegment(segment.id)"></i><i v-if="canManageSegment()" class="icon fa fa-pencil float-right clickable" @click="edit(segment)"></i></item-list>
              </SlickList>
            </b-col>
            <b-col md="6">
              <b-card :header-bg-variant="action === 'create' ? 'primary' : 'warning' ">
                <template v-slot:header >
                   <i class="fa fa-justify mr-2"></i>
                  <strong>{{ libelleFormCardTitle }}</strong>
                </template>
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      label='Libellé'
                      label-for='libelle'
                    >
                      <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.libelle }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Libellé technique'
                      label-for='libelleTechnique'
                    >
                      <b-form-input id='libelleTechnique' type='text' v-model="libelleTechnique" :class="{hasError: errors.libelleTechnique !== ''}" :disabled="action !== 'create'"></b-form-input>
                      <span class='field-error'>{{ errors.libelleTechnique }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Code'
                      label-for='code'
                    >
                      <b-form-input id='code' type='text' v-model="code" :class="{hasError: errors.code !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.code }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-button v-if="action === 'create'" size="md" variant="primary" @click="create()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Créer</b-button>
                    <b-button v-if="action === 'modify'" size="md" variant="warning" @click="modify()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Modifier</b-button>
                    <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-2 mt-1 pull-right">
                      <i class="fa fa-eraser"></i> Annuler
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper"
import { SlickList } from 'vue-slicksort'
import itemList from '@/components/SortListItem'

export default {
  components: {
    SlickList,
    itemList
  },
  data() {
    return {
      segmentId: '',
      allSegments: [],
      libelle: '',
      libelleTechnique: '',
      code: '',
      action: 'create',
      libelleFormCardTitle: 'Création d\'un segment de dossier',
      errors: {
        libelle: '',
        libelleTechnique: '',
        code: '',
      }
    }
  },
  watch: {
    allSegments: function() {
      if (this.canManageSegment()) {
        this.sorted()
      }
    },
  },
  mounted() {
    this.getSegments()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    getSegments() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/espaceGestion/dossier/getAllSegment")
        .then(response => {
          this.$store.commit("IS_LOADING", false)

          this.allSegments = response.data.data
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    sorted() {
      // console.log(this.allBaskets)
      let self = this;
      let dataPost = {
        'provider': getProvider(),
        'segments': this.allSegments
      }
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/espaceGestion/parametrage/segment/sort', dataPost)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
          // console.log(response)
          // this.groupBals = _.groupBy(response.data.bals,'entreprise')
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue lors du tri, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    create() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'libelle_technique': this.libelleTechnique,
          'code': this.code,
          'ordre': 99,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/parametrage/segment/add', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearForm()
            this.clearError()
            this.getSegments()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la création du segment, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    modify() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'libelle_technique': this.libelleTechnique,
          'code': this.code,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/parametrage/segment/modify/'+this.segmentId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearForm()
            this.clearError()
            this.getSegments()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la modification du segment, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    deleteSegment(segmentId) {
      let self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer ce segment ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true)
            this.$axios
              .get("/espaceGestion/parametrage/segment/delete/"+segmentId).then(response => {
                this.$store.commit("IS_LOADING", false)
                this.getSegments()
              })
              .catch(function(error) {
                  self.$store.commit("IS_LOADING", false)
                  let errorText = "Une erreur est survenue, lors de la suppression du segment. Si le problème persiste, merci de faire un ticket au support DOSI."
                  if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                  if (error.response.status === 406) { errorText =  error.response.data.message}
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
    },
    canManageSegment() {
      return hasRule(rules.CAN_CONFIGURE_DOSSIER)
    },
    edit(segment) {
      this.libelle = segment.libelle
      this.libelleTechnique = segment.libelle_technique
      this.code = segment.code
      this.segmentId = segment.id
      this.action = 'modify'
      this.libelleFormCardTitle = 'Modification du segment : ' + segment.libelle
    },
    validate() {
      let valid = true

      if (this.libelle === '') {
        this.errors.libelle = 'Le libelle est obligatoire'
        valid = false;
      }

      if (this.libelleTechnique === '') {
        this.errors.libelleTechnique = 'Le libelle technique est obligatoire'
        valid = false;
      }

      if (this.code === '') {
        this.errors.code = 'Le code est obligatoire'
        valid = false;
      }

      return valid
    },
    clearForm() {
      this.clearError()
      this.libelle = ''
      this.libelleTechnique = ''
      this.code = ''
      this.segmentId = ''
      this.action = 'create'
      this.libelleFormCardTitle = 'Création d\'un segment de dossier'
    },
    clearError() {
      this.errors.libelle = ''
      this.errors.libelleTechnique = ''
      this.errors.code = ''
    },
  }
}
</script>
